<template>
	<div class="case-editors">
		
		<InputGroup
			title="Set Supporting Surgeons"
			desc="Select other users who can view and edit this case. Use the search box to filter users by name."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			<MultiSelect
				:options="editorsDisabledMainSurgeon"
				v-model="caseForm.editors"
				:showAsTags="['case_relation']"
				/>      
		</InputGroup>


		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:condensed="true"
			:oneColumn="true"
			:fixedToBottom="true"
			>
			<Button
				label="Save"
				color="green"
				size="large"
				icon="save" 
				@click="submitCaseEditors"
				/>
		</InputGroup>


	</div>
</template>

<script>

import InputGroup from "@/Components/InputGroup"
import Button from "@/Components/Button"
import MultiSelect from "@/Components/MultiSelect"

export default {
	props: [
		'thisCase',
		'editors'
	],
	components: {
		InputGroup,
		Button,
		MultiSelect
	},
	data: () => {
		return {
			caseForm: {
				editors: []
			},
		}
	},
	mounted(){
		this.caseForm.editors = this.thisCase.editors.map(viewer => viewer.id) // load in existing values
	},
	methods: {
		submitCaseEditors(){
			this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/editors`, this.caseForm)
		},
	},
	computed: {
		editorsDisabledMainSurgeon(){
			// if this.thisCase.user_id is in editors, add attribute 'disabled' to that user
			return this.editors.map(editor => {
				if(editor.id === this.thisCase.user_id){
					return {
						...editor,
						case_relation: 'Primary Surgeon',
						disabled: true
					}
				}else if(Array.isArray(this.thisCase.viewers) && this.thisCase.viewers.find(e => e && e.id === editor.id)){
					return {
						...editor,
						case_relation: 'Viewer',
						disabled: true
					}

				} else {
					return editor
				}
			})
		}
	}
}

</script>

<style scoped lang="sass">

.case-editors
	select[multiple]
		width: 100%
		min-height: 200px



</style>